import * as types from '../../actionTypes'

export const setLicenseSearchQuery = (key, value) => {
  return {
    type: types.SET_LICENSE_SEARCH_QUERY,
    criteria: { [key]: value },
  }
}

export const clearLicenses = () => {
  return {
    type: types.CLEAR_LICENSES,
  }
}

export const fetchingLicenses = () => ({
  type: types.FETCHING_LICENSES,
})

export const fetchingLicensesError = (
  errorMessage = 'Error fetching licenses',
) => {
  return {
    type: types.FETCHING_LICENSES_ERROR,
    error: errorMessage,
  }
}

export const fetchingLicensesNotFound = () => {
  return {
    type: types.FETCHING_LICENSES_NOT_FOUND,
  }
}

export const fetchingUserLicenses = () => ({
  type: types.FETCHING_USER_LICENSES,
})
export const fetchingUserLicensesSuccess = licenses => ({
  licenses,
  type: types.FETCHING_USER_LICENSES_SUCCESS,
})
export const fetchingUserLicensesError = error => ({
  error,
  type: types.FETCHING_USER_LICENSES_ERROR,
})

export const fetchSubscriptionSuccess = subscription => {
  return {
    type: types.FETCHING_SUBSCRIPTION_FOR_LICENSES,
    subscription,
  }
}

export const fetchingLicensesSuccess = licenses => {
  return {
    type: types.FETCHING_LICENSES_SUCCESS,
    licenses,
  }
}

export const fetchingLicenseSuccess = license => {
  return {
    type: types.FETCHING_LICENSE_SUCCESS,
    license,
  }
}

export const savingLicense = () => ({
  type: types.SAVING_LICENSE,
})

export const savingLicenseSuccess = license => {
  return {
    type: types.SAVING_LICENSE_SUCCESS,
    license,
  }
}

export const savingLicenseError = err => {
  return {
    type: types.SAVING_LICENSE_ERROR,
    error: err,
  }
}

export const sendingLicenseInvite = () => {
  return {
    type: types.SENDING_LICENSE_USER,
  }
}

export const sendingLicenseInviteError = (
  error = 'There was a problem submitting an invite license users.',
) => {
  return {
    type: types.SENDING_LICENSE_USER_ERROR,
    error,
  }
}

export const sendingLicenseInviteSuccess = licenseUserPayload => {
  return {
    type: types.SENDING_LICENSE_USER_SUCCESS,
    licenseUserPayload,
  }
}

export const sendingLicenseInviteBulk = () => {
  return {
    type: types.SENDING_LICENSE_USER_BULK,
  }
}

export const sendingLicenseInviteBulkError = (
  error = 'There was a problem submitting an invite license users.',
) => {
  return {
    type: types.SENDING_LICENSE_USER_BULK_ERROR,
    error,
  }
}

export const sendingLicenseInviteBulkSuccess = results => {
  return {
    type: types.SENDING_LICENSE_USER_BULK_SUCCESS,
    results,
  }
}

export const resetBulkUsersAdd = () => {
  return {
    type: types.RESET_BULK_ADD_USERS,
  }
}

export const deletingLicenseUser = () => {
  return {
    type: types.DELETING_LICENSE_USER,
  }
}

export const deletingLicenseUserError = (
  error = 'There was a problem deleting an invited license user.',
) => {
  return {
    type: types.DELETING_LICENSE_USER_ERROR,
    error,
  }
}

export const deletingLicenseUserSuccess = (licenseId, email) => {
  return {
    type: types.DELETING_LICENSE_USER_SUCCESS,
    licenseId,
    email,
  }
}

export const grantingNewRoleLicenseUser = () => {
  return {
    type: types.GRANTING_NEW_ROLE_LICENSE_USER,
  }
}

export const grantingNewRoleLicenseUserError = (
  error = 'Failed to grant user the new role',
) => {
  return {
    type: types.GRANTING_NEW_ROLE_LICENSE_USER_ERROR,
    error,
  }
}

export const grantingNewRoleLicenseUserSuccess = (email, licenseId, roles) => {
  return {
    type: types.GRANTING_NEW_ROLE_LICENSE_USER_SUCCESS,
    email,
    licenseId,
    roles,
  }
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/licenseManager/actions.js